import React from 'react'
import Heading from 'presentation/shared/components/Heading'
import Logo from 'presentation/shared/components/Logo'
import SupportText from 'presentation/shared/components/SupportText'

import * as S from './styles'
import LoginForm from 'presentation/shared/components/Forms/Login'
import { Authentication } from 'domain/usecases/authentication/authentication'

type HospitalLoginLayoutProps = {
  authentication: Authentication
}

export default function HospitalLoginLayout({
  authentication
}: HospitalLoginLayoutProps) {
  return (
    <S.Wrapper>
      <div className={'container'}>
        <S.Header>
          <Logo
            size="huge"
            style={{
              display: 'inline-block'
            }}
          />
          <Heading as="h1" size="large" style={{ fontWeight: 700 }}>
            Bem-vindo(a) ao <strong>Meu Mater Dei</strong>
          </Heading>
          <SupportText>
            Acesse a plataforma para acompanhar seus processos e procedimentos
            na Rede Mater Dei.
          </SupportText>
        </S.Header>
        <LoginForm useCase={authentication} />
      </div>
    </S.Wrapper>
  )
}
